export default __webpack_public_path__ + "static/media/hobby.08f6c84b.png";